"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const Picasso_1 = require("../Picasso");
Picasso_1.PicassoProvider.override(() => ({
    MuiStepLabel: {
        label: {
            paddingLeft: '0.5em',
            fontSize: '0.6875em',
            fontWeight: 600,
            lineHeight: '1em',
            '&$active': {
                display: 'block'
            }
        },
        iconContainer: {
            paddingRight: 0
        }
    }
}));
exports.default = () => styles_1.createStyles({
    hidden: {
        display: 'none'
    }
});
//# sourceMappingURL=styles.js.map